import React from "react";

interface IProps {
  pages: number;
  page: number;
  bottom: boolean;
  setPage: any;
}

const Pager = ({
  pages,
  page,
  bottom,
  setPage
}: IProps) => (
  <div className="paging">
    <div className={`bordered ${bottom ? "bottom" : ""}`}>
      <ul>
        {page > 1
          ? <li className="prev">
            <a
              href="#"
              onClick={() => setPage(page - 1)}
            >
              Previous
            </a>
        </li> : <></>
        }
        {pages > 6
          ? <>
            <li className={`${page === 1 ? "active" : ""}`}>
              <a
                href="#"
                onClick={() => setPage(1)}
              >
                1
              </a>
            </li>
            {page > 4
              ? <>
                <li className="separator">&hellip;</li>
                <li>
                  <a
                    href="#"
                    onClick={() => setPage(page - 1)}
                  >
                    {page - 1}
                  </a>
                </li>
                {page < pages
                  ? <li className="active">
                    <a
                      href="#"
                      onClick={() => setPage(page)}
                    >
                      {page}
                    </a>
                </li> : <></>
                }
                {page < pages - 1
                  ? <li>
                    <a
                      href="#"
                      onClick={() => setPage(page + 1)}
                    >
                      {page + 1}
                    </a>
                  </li> : <></>
                }
              </>
              : <>
                <li className={`${page === 2 ? "active" : ""}`}>
                  <a
                    href="#"
                    onClick={() => setPage(2)}
                  >
                    2
                  </a>
                </li>
                <li className={`${page === 3 ? "active" : ""}`}>
                  <a
                    href="#"
                    onClick={() => setPage(3)}
                  >
                    3
                  </a>
                </li>
                <li className={`${page === 4 ? "active" : ""}`}>
                  <a
                    href="#"
                    onClick={() => setPage(4)}
                  >
                    4
                  </a>
                </li>
                <li className={`${page === 5 ? "active" : ""}`}>
                  <a
                    href="#"
                    onClick={() => setPage(5)}
                  >
                    5
                  </a>
                </li>
              </>
            }
            {page < pages - 2
              ? <li className="separator">&hellip;</li> : <></>
            }
            <li className={`${page === pages ? "active" : ""}`}>
              <a
                href="#"
                onClick={() => setPage(pages)}
              >
                {pages}
              </a>
            </li>
          </>
          : Array(pages).fill(0).map((i, index) => <li className={`${page === index + 1 ? "active" : ""}`}>
            <a
              href="#"
              onClick={() => setPage(index + 1)}
            >
              {index + 1}
            </a>
          </li>)
        }
        {page < pages
          ? <li className="next">
            <a
              href="#"
              onClick={() => setPage(page + 1)}
            >
              Next
            </a>
        </li> : <></>
        }
      </ul>
    </div>
  </div>
);

export default Pager;
